import { fromJS } from 'immutable'
import { saveUser } from 'utils/auth'

import {
  UPDATE_USER
} from './constants'


export const initialState = fromJS({
  user: {}
})


export default function reducer(state = initialState, action) {
  switch(action.type){
    case UPDATE_USER:
      saveUser(action.user)
      return state.set('user', action.user)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/global/user/index.js